import { Checkbox, Stack, TableCell, TableHead, TableRow, Tooltip } from '@mui/material';
import React, { memo } from 'react';
import PropTypes from 'prop-types';

function DocumentsTableHead({ handleSelectAll, disabled, checked }) {
  return (
    <TableHead>
      <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
        <TableCell sx={{ width: { xs: '150px', sm: '25%' }, minWidth: '120px', fontWeight: 600 }}>
          <Stack direction="row" alignItems="center">
            <Tooltip title="Select All">
              <Checkbox
                sx={{ p: 0, mr: 2 }}
                disabled={disabled}
                checked={checked}
                onChange={handleSelectAll}
              />
            </Tooltip>
            Date
          </Stack>
        </TableCell>
        <TableCell sx={{ width: { xs: '120px', sm: '15%' }, minWidth: '100px', fontWeight: 600 }}>
          Type
        </TableCell>
        <TableCell sx={{ width: { xs: '150px', sm: '25%' }, minWidth: '120px', fontWeight: 600 }}>
          Vendor
        </TableCell>
        <TableCell sx={{ width: { xs: '120px', sm: '15%' }, minWidth: '100px', fontWeight: 600 }}>
          Amount
        </TableCell>
        <TableCell
          sx={{ width: { xs: '150px', sm: '30%' }, minWidth: '120px', pr: 2, fontWeight: 600 }}
          align="right"
        >
          Actions
        </TableCell>
      </TableRow>
    </TableHead>
  );
}

DocumentsTableHead.propTypes = {
  handleSelectAll: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  checked: PropTypes.bool.isRequired,
};

export default memo(DocumentsTableHead);
